import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../../shared";
import { ClassAttendanceAddMultiplePBISRequest } from "./ClassAttendanceAddMultiplePBISRequest";

@Injectable()
export class AddPointService {
	constructor(private httpclientService: HttpclientService) {}

	PointsItemGetList(categoryTypeID, schoolID) {
		var postResult$ = new Subject();
		var url = "attendance/PointsItemGetList?categoryTypeID=" + categoryTypeID + "&schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TransactionInsert(points) {
		var postResult$ = new Subject();
		//  var url = "attendance/TransactionInsert?PointsItemID=" + points.PointsItemID + "&PointsItemValue=" + points.PointsItemValue + "&PointsTransactionTypeID=" + points.PointsTransactionTypeID + "&SchoolID=" + points.SchoolID + "&PersonID=" + points.PersonID;
		var url = "attendance/TransactionInsert";

		var promise$ = this.httpclientService.post(url, points);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceAddMultiplePBIS(parms: ClassAttendanceAddMultiplePBISRequest) {
		var postResult$ = new Subject();
		var url = "attendance/ClassAttendanceAddMultiplePBIS";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
